
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts/[pageNumber]",
      function () {
        return require("private-next-pages/podcasts/[pageNumber]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts/[pageNumber]"])
      });
    }
  